import Marionette from "backbone.marionette";
import InstanceModel from "models/instanceModel.js";
import ParamTpl from "views/parameters/parametersView.ejs";
import CSS from "views/parameters/parameters.css";

import S from "session/session.js";
import T from "session/token.js";

var bootbox = require('bootbox');

export default Marionette.View.extend({
    instanceModel: null,
    template: ParamTpl,
    render: function() {
        $('.content-wrapper').css({ 'margin-left': '230px' });

        $("#loaderContainer").show();
        this.model.fetch({
            data: {
                instanceId: S.instanceId,
                action: "edit"
            },
            beforeSend: T.useToken,
            success: this.applyView.bind(this)
        });

    },
    applyView: function() {
        this.instanceModel = new InstanceModel({
            id: S.instanceId
        });
        this.instanceModel.fetch({
            success: function(instanceData) {
                this.$el.html(this.template({
                    attributes: this.model.attributes,
                    lang: this.model.attributes.lang,
                    type: this.model.attributes.type,
                    ejercicio: this.model.attributes.ejercicio,
                    rolUs: S.userInfo.get("role"),
                    areas: S.areas,
                    instanceData: instanceData.attributes
                }));
            }.bind(this),
            error: function() {

            }
        })

        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li").removeClass("menu-open");
        $(".sidebar li > ul").removeClass("menu-open").css("display", "none");
        // Add active menu items
        $("#PARAMETERS").parent().addClass("active");

        $("#ejercicio").datetimepicker({
            format: 'DD-MM-YYYY',
        });

        $("#loaderContainer").hide();


    },
    restoreAreasParent: function() {
        var params = this.model.toJSON();
        //Select group for areas
        for (var a in params.areas) {
            $('#areas tr[data-uniqueid="' + params.areas[a].id + '"] select#area').val(params.areas[a].parent_id);
        }
    },
    events: {
        "click #recalcularAmortizaciones": "recalcularAmortizaciones",
        "click #guardarEjercicio": "guardarEjercicio",
        "click #amortizaciones-tab": "applyDatepicker",
        "click button.save": "save",
        "click button.saveMajor": "saveMajor",
        "click button.savePercent": "savePercent",
        "click button.saveGis": "savegisconfig",
        "click button.add": "add",
        "click .delete": "delete",
        "change .vida_util": "changeVidaUtil",
        "change .amortizan": "changeAmortizacion"
    },
    add: function(ev) {
        var pane = $(ev.target).parents(".tab-pane");
        var area = pane.attr("id");
        var table = pane.find("table.hasData tbody");
        var row = table.find("tr.model-row").clone();
        row.removeClass("hidden");
        row.attr("id", ""); // Empty Id
        row.find("td:first").html('<p style="display:none;">&nbsp;</p>');
        row.find("input, select").each(function() {
            $(this).val('');
        });
        row.appendTo(table);
    },
    delete: function(ev) {
        // Confirmations         
        ev.preventDefault();
        $(ev.currentTarget).confirmation({
                rootSelector: ".delete",
                placement: 'left',
                singleton: true,
                title: S.userInfo.attributes.lang.SAVING_PENDING,
                popout: true,
                onConfirm: function() {
                    var pane = $(ev.currentTarget).parents(".tab-pane");
                    var tr = $(ev.currentTarget).parents("tr");
                    tr.remove();
                },
                btnOkClass: 'btn-sm btn-danger',
                btnOkLabel: S.userInfo.attributes.lang.ACCEPT,
                btnCancelClass: 'btn-sm btn-default',
                btnCancelLabel: S.userInfo.attributes.lang.CANCEL,

            })
            // Needed to show on first attemp
        $(ev.currentTarget).confirmation('show');
    },
    save: function(ev) {
        ev.preventDefault();
        var myModel = this;



        bootbox.confirm(S.userInfo.attributes.lang.SAVING_CONFIRM, function(confirmationResult) {
            if (confirmationResult) {
                var pane = $(ev.target).parents(".tab-pane.active");
                var area = pane.attr("id");
                var fields = pane.find("table.hasData th");

                var rows = pane.find("table.hasData tbody tr");
                var out = [];
                rows.each(function() {
                    var record = {};
                    if ($(this).attr("id") != "rowTemplate") {
                        $(this).find("td").each(function(trId) {

                            if (this.firstChild.nodeName === "#text") {
                                record['nodo'] = $(this).first().html();
                            }

                            if ($(this).find(".tEs").val()) {
                                record['es'] = $(this).find(".tEs").val();
                            }

                            if ($(this).find(".tCat").val()) {
                                record['cat'] = $(this).find(".tCat").val();
                            }

                            // Amortización
                            if ($(this).find(".epigraph").val()) {
                                record['epigraph'] = $(this).find(".epigraph").val();
                            }

                            if ($(this).find(".cc_inmobil").val()) {
                                record['cc_inmobil'] = $(this).find(".cc_inmobil").val();
                            }

                            if ($(this).find(".cc_encurso").val()) {
                                record['cc_encurso'] = $(this).find(".cc_encurso").val();
                            }

                            if ($(this).find(".amortizan").val()) {
                                record['amortizan'] = $(this).find(".amortizan").val();
                            }

                            if ($(this).find(".amortizacion").val()) {
                                record['amortizacion'] = $(this).find(".amortizacion").val();
                            }

                            if ($(this).find(".vida_util").val()) {
                                record['vida_util'] = $(this).find(".vida_util").val();
                            }

                            // Parents de EPIGRAFS o AREAS FUNCIONALES
                            if ($(this).find("#idareparent").val()) {
                                record['idParent'] = $(this).find("#idareparent option:selected").val();
                            }
                        });
                    }
                    out.push(record);
                });



                myModel.model.save({
                    table: out,
                    tableNodo: area,
                    instanceId: S.instanceId
                }, {
                    beforeSend: T.useToken,
                    success: function() {
                        S.mApp.trigger("notify:success", {
                            message: S.userInfo.attributes.lang.INSERT_OK
                        });
                    },
                    error: function() {
                        S.mApp.trigger("notify:error", {
                            message: S.userInfo.attributes.lang.INSERT_ERROR
                        });
                    }
                });
            }
        });
    },
    saveMajor: function(ev) {
        $("#loaderContainer").show();
        var formData = {};
        formData.nombreSecretario = $("#nombreSecretario").val();
        formData.nombreAlcalde = $("#nombreAlcalde").val();
        formData.instanceId = S.instanceId;
        formData.table = "informes";


        this.submitMajor(formData);
    },
    submitMajor: function(formData) {
        this.model.save(formData, {
            beforeSend: T.useToken,
            success: function() {
                S.mApp.trigger("notify:success", {
                    message: S.userInfo.attributes.lang.INSERT_OK
                });
                $("#loaderContainer").hide();
            },
            error: function() {
                S.mApp.trigger("notify:error", {
                    message: S.userInfo.attributes.lang.INSERT_ERROR
                });
                $("#loaderContainer").hide();
            }
        });
    },
    savePercent: function(ev) {

        $("#loaderContainer").show();
        var formData = {};
        formData.porcentaje = $("#porcentaje").val();
        formData.instanceId = S.instanceId;
        formData.table = "porcentaje";


        this.submitPercent(formData);
    },
    savegisconfig: function(ev) {

        $("#loaderContainer").show();
        var formData = {};
        formData.gismunicipio = $("#gismunicipio").val();
        formData.sisterepres = $("#sistemepsg").val();
        formData.instanceId = S.instanceId;
        formData.table = "gisconfig";


        this.submitPercent(formData);
    },

    submitPercent: function(formData) {
        this.model.save(formData, {
            beforeSend: T.useToken,
            success: function() {
                S.mApp.trigger("notify:success", {
                    message: S.userInfo.attributes.lang.INSERT_OK
                });
                $("#loaderContainer").hide();
            },
            error: function() {
                S.mApp.trigger("notify:error", {
                    message: S.userInfo.attributes.lang.INSERT_ERROR
                });
                $("#loaderContainer").hide();
            }
        });
    },

    changeVidaUtil: function(ev) {
        var amortizan = $(ev.target).parents("tr").find(".amortizan");
        var amortizacion = $(ev.target).parents("tr").find(".amortizacion");
        var value = parseInt($(ev.target).val());
        if (value > 0) {
            amortizan.val("1");
            amortizacion.val(100 / value);
        } else {
            amortizan.val("0");
            amortizacion.val(0);
        }
    },
    changeAmortizacion: function(ev) {
        var value = parseInt($(ev.target).val());
        var amortizacion = $(ev.target).parents("tr").find(".amortizacion");
        var vida_util = $(ev.target).parents("tr").find(".vida_util");
        if (value === 0) {
            amortizacion.val(0);
            vida_util.val(0);
        }
    },
    recalcularAmortizaciones: function() {
        // Calculate amortizaciones
        var confirmTitle = this.model.attributes.lang.RECALCULAR_WARNING;
        bootbox.confirm(confirmTitle, function(response) {
            if (response) {

                var xhr = new XMLHttpRequest();
                var instance_id = S.instanceId;
                var date = $("#ejercicio").val();
                var action = "process";
                S.mApp.trigger("recalculateAmortizaciones"); // mainView.js is listening  
                xhr.open('POST', 'api/goods/amortizaciones.php', true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
                xhr.responseType = 'arraybuffer';
                xhr.onload = function(e) {
                    if (this.status != 200) {
                        $("processingAmortizaciones").addClass("hidden");
                        bootbox.alert("ERROR");
                    }
                };
                xhr.send(JSON.stringify({ instance_id: instance_id, date: date, action: action }));

            }
        });
        return;

    },
    guardarEjercicio: function() {
        // Guardar Ejercicio
        $("#loaderContainer").show();
        var xhr = new XMLHttpRequest();
        var instance_id = S.instanceId;
        var date = $("#ejercicio").val();
        var action = "save";
        xhr.open('POST', 'api/goods/amortizaciones.php', true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function(e) {
            if (this.status != 200) {
                $("processingAmortizaciones").addClass("hidden");
                bootbox.alert("ERROR");
            }
            $("#loaderContainer").hide();
        };
        xhr.send(JSON.stringify({ instance_id: instance_id, date: date, action: action }));
        return;

    },
    applyDatepicker: function() {
        $("#ejercicio").datetimepicker({
            format: 'DD-MM-YYYY',
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/parameters/parametersView.js
// module id = 199
// module chunks = 0